<app-modal [title]="'Registrar nuevo contacto'">
    <app-form [formGroup]="saveForm">
      <div class="grid grid-cols-1 gap-3 md:grid-cols-2 mb-5">
        <div>
          <app-label for="param_canal_contacto_id">
            Canal de contacto
          </app-label>
          <app-select id="param_canal_contacto_id" formControlName="param_canal_contacto_id" placeholder="Seleccione un canal" [options]="canalesContactosOptions" />
        </div>

        <div>
          <app-label for="param_motivo_contacto_id">
            Motivo de contacto
          </app-label>
          <app-select id="param_motivo_contacto_id" formControlName="param_motivo_contacto_id" placeholder="Seleccione un motivo" [options]="motivosContactoOptions" />
        </div>

        <div>
          <app-label for="crm_campanha_id">
            Campaña
          </app-label>
          <app-select id="crm_campanha_id" formControlName="crm_campanha_id" placeholder="Seleccione una campaña" [options]="campanhasOptions" />
        </div>

        <div>
          <app-label for="param_estado_contacto_id">
            Estado
          </app-label>
          <app-select id="param_estado_contacto_id" formControlName="param_estado_contacto_id" placeholder="Seleccione un estado" [options]="estadosContactosOptions" />
        </div>

        <div>
          <app-label for="fecha">
            Fecha
          </app-label>
          <app-input-field id="fecha" name="fecha" type="datetime-local" formControlName="fecha" [className]="'dark:scheme-dark'" />
        </div>
      </div>

      <div>
        <app-label for="resultado">
          Resultado
        </app-label>
        <app-textarea id="resultado" formControlName="resultado" [rows]="4" />
      </div>
    </app-form>

    <app-creation-buttons *hasPermission="'prospectos:create'"
      [valid]="saveForm.valid"
      [process]="loading"
      (onCreateClick)="create()"
      (onCancelClick)="cancel()"
    />
</app-modal>
